<template>
  <transition name="fadeOut">
    <div v-if="show" class="modal__cover" :style="style" @click.stop>
      <div
        class="modal__container"
        :style="{ transform: `scale(${scale * 1}) translate3d(0, -50%, 0)` }"
        :data-type="type"
      >
        <div class="modal__inner">
          <div class="modal__header">
            <div class="title" @click="$emit('clickTitle')">
              <div class="bg">
                <div class="prefix"></div>
                <div class="middle"></div>
                <div class="suffix"></div>
              </div>
              <div v-if="iconType" class="icon" :class="iconType"></div>
              <div class="label-box">
                <span class="label-shadow">{{ title }}</span>
                <span class="label-text">{{ title }}</span>
              </div>
            </div>
            <div v-if="decorate" class="decorate"></div>
            <div class="modal__header-right">
              <slot name="header-right"></slot>
            </div>
            <div class="close" @click="$emit('close')"></div>
          </div>
          <div class="modal__body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'UiModal',
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    type: {
      type: String,
      default: () => 'tag' // tag: 卡片样式 tabs 铺满的表格样式
    },
    title: {
      type: String,
      default: () => '弹窗标题'
    },
    iconType: {
      type: String,
      default: () => ''
    },
    decorate: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      style: {}
    }
  },
  computed: {
    ...mapState(['scale', 'clientSize'])
  },
  watch: {
    show: {
      handler(newVal) {
        if (newVal) {
          this.resetHeight()
        }
      }
    },
    clientSize: {
      handler(newVal, oldVal) {
        if (newVal != oldVal && this.show) {
          this.resetHeight()
        }
      },
      deep: true
    }
  },
  methods: {
    resetHeight() {
      this.style = { height: `${window.innerHeight + 1}px` }
    }
  }
}
</script>

<style lang="scss" scoped>
.fadeOut-enter-active {
  transition: opacity 0.1s linear;
}
.fadeOut-leave-active {
  transition: opacity 0.1s linear;
}
.fadeOut-enter,
.fadeOut-leave-to {
  opacity: 0;
}

.modal__cover {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 60;

  .modal__container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1096px;
    height: 645px;
    background-image: $bg_popup;
    border-radius: 20px;
    margin-left: -0.5 * 1096px;
    overflow: hidden;
    transform-origin: center 0;
    transform: translate3d(0, -50%, 0);
    display: flex;

    .modal__header {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .decorate {
        width: 83px;
        height: 84px;
        background-image: $bg_decorate;
        background-size: 1472px 639px;
        background-position: -1345px -229px;
        background-repeat: no-repeat;
        position: absolute;
        top: 8px;
        left: 902px;
      }

      .close {
        position: absolute;
        top: 8px;
        right: 5px;
        background-image: $icon_close;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
      }
      
      .modal__header-right {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 84px;
      }
    }

    .modal__body {
      min-height: 200px;
    }

    &[data-type='tabs'] {
      .modal__header {
        @include linear-gradient();
        height: 60px;

        .title {
          font-size: 26px;
          font-weight: 500;
          color: #fff;
          margin-left: 30px;
        }
        .close {
          width: 41px;
          height: 26px;
          margin-right: 15px;
        }
      }
    }

    &[data-type='tag'] {
      .modal__inner {
        display: flex;
        flex-direction: column;
        width: 1067px;
        margin: 8px auto 14px;
        overflow: hidden;
        .modal__header {
          height: 55px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: -8px;

          .title {
            position: relative;
            min-width: 170px;
            height: 100%;
            font-size: 26px;
            font-weight: 500;
            padding: 0 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1;
            .bg {
              position: absolute;
              top: 6px;
              left: 0;
              width: 100%;
              min-width: 130px;
              height: 55px;
              display: flex;
              .prefix {
                width: 55px;
                height: 100%;
                background-image: url('https://website.xdcdn.net/poster/58881/20250717/K8VfTkLw.png');
                background-size: 100% 100%;
                background-position: center;
                background-repeat: no-repeat;
              }
              .middle {
                flex: 1;
                height: 100%;
                background-image: url('https://website.xdcdn.net/poster/58881/20250717/K8VfTQAz.png');
                background-size: 100% 100%;
                background-position: center;
                background-repeat: no-repeat;
                margin-left: -2px;
              }
              .suffix {
                position: absolute;
                top: 0;
                right: -58px;
                width: 60px;
                height: 100%;
                background-image: url('https://website.xdcdn.net/poster/58881/20250717/K8VXzCas.png');
                background-size: 100% 100%;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
            .icon {
              position: relative;
              width: 36px;
              height: 36px;
              margin-right: 4px;
              margin-top: 10px;
              &.notice {
                @include icon_status('apply_2', $hook: 'px');
              }
              &.team {
                @include icon_status('team_1', $hook: 'px');
              }
              &.tip {
                @include icon_status('tip_2', $hook: 'px');
              }
              &.store_2 {
                @include icon_status('store_2', $hook: 'px');
              }
              &.ranking_2 {
                @include icon_status('ranking_2', $hook: 'px');
              }
              &.remind {
                width: 38px;
                height: 38px;
                @include icon_status('icon_rule_event', $hook: 'px');
                margin-right: 8px;
              }
              &.gift_2 {
                @include icon_status('gift_2', $hook: 'px');
              }
              &.quiz_2 {
                @include icon_status('quiz_2', $hook: 'px');
              }
            }
            .label-box {
              margin-top: 10px;
              .label-shadow {
                color: #FFFFFF;
              }
              .label-text {
                color: #345281;
              }
            }
          }
          .close {
            width: 51px;
            height: 28px;
            margin: 0 10px 7px 0;
          }
        }
        .modal__body {
          flex: 1;
          display: flex;
          flex-direction: column;
          position: relative;
          background-image: $bg_popup_inner;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 0px 10px 10px 10px;
          overflow: hidden;
        }
      }
    }
  }
}
</style>